import React from "react";
import PropTypes from "prop-types";

function Label({ label, fontClass }) {
  return (
    <div className="b-labels-container">
      <span className={`font-bold b-labels-container__text${fontClass}`}>
        {label}
      </span>
    </div>
  );
}

Label.propTypes = {
  label: PropTypes.string.isRequired,
  fontClass: PropTypes.string,
};

Label.defaultProps = {
  fontClass: "",
};

export default Label;
